module.exports = __webpack_public_path__ + "img/hotel-beds.ad0463ed.jpeg";